<template>
	<div class="status">
		<el-tag :effect="effect" :type="type">{{ status }}</el-tag>
	</div>
</template>

<script>
import Column from '.'

export default {
	name: 'message-status-column',
	extends: Column,

	computed: {
		effect() {
			if (this.row.status === 'sent' && (this.row.opened || this.row.accepted))
				return 'dark'
			return 'light'
		},
		type() {
			if (this.row.status === 'sent')
				return 'success'
			else if (this.row.status === 'error')
				return 'danger'
			else
				return 'info'
		},
		status() {
			if (this.row.status === 'sent') {
				if (this.row.accepted)
					return 'Accepted'
				if (this.row.opened)
					return 'Opened'
				return 'Sent'
			}
			else if (this.row.status === 'ready') {
				return 'Queued'
			}
			else return this.row.status
		}
	}
}
</script>
